import './FourByEightLabel.scss';

import React, { Component } from 'react';

import Logger from '@KrashidBuilt/common/utils/logger';

import FourBySixLabel from '../FourBySixLabel';
import { LabelChecklist } from '../../components';

const logger = new Logger('FourByEightLabel');

export default class FourByEightLabel extends Component {
    render() {
        logger.extra({ _: this });
        return (
            <div className={'FourByEightLabel'}>
                {/* always disable the qr code for the 4x6 part image label */}
                <FourBySixLabel {...this.props} rotate={false} qrDisabled={true} />
                <LabelChecklist  {...this.props} />
            </div>
        );
    }
}
